/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.userProducts.internal

import features.userProducts.models.UserProductsModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class UserProductsServiceImpl : UserProductsService {

    private val userProductsRequest = UserProductsRequest()

    override suspend fun getUserProducts(
        overrideHeaders : Map<String, String>?,
    ): Result<UserProductsModel> {
        return userProductsRequest.getUserProducts(
            overrideHeaders = overrideHeaders,
        ).toModel()
    }
}
